import * as React from 'react';
import * as  moment from 'moment';
import formats from '../../../../const/formats';
import copyJSONToBuffer from '../../../../services/mini/copyJSONToBuffer';
import ToasterService from '../../../../services/ToasterService';
import { ICommandData } from '../../../../models/IChatMessage';
import FileLineLocInfo from '../FileLineLocInfo/FileLineLocInfo';
import { FileLineLocInfoTypes } from '../FileLineLocInfo/FileLineLocInfoTypes';

type CommandInfoProps = {
    command: ICommandData
    index: number
    closePanelCb: () => void
}

export function CommandInfo({ command, index, closePanelCb }: CommandInfoProps) {

    const copyCb = React.useCallback(() => {
        copyJSONToBuffer(command.data);
        ToasterService.showInfo({
            position: 'bottom-left',
            title: 'Copied to clipboard'
        });
    }, [command.data]);

    return <div className="command-info" data-command-info={index}>
        <div className="command-info_header">
            <div className="command-info_header_title">
                <FileLineLocInfo
                    locData={command.ctx.rLoc}
                    type={FileLineLocInfoTypes.Response}
                    onAfterClick={closePanelCb}
                />
            </div>
            <div className="command-info_header_copy-btn action-btn light-blue-with-border"
                onClick={copyCb}>
                Copy
            </div>
        </div>
        <pre>{JSON.stringify(command.data, null, ' ')}</pre>
    </div>;
}